<template>
  <div id="switch-page">
    <div class="row no-margin-bottom switch-page-spacing" style="margin-top: 5px">
      <div class="col">
        <RailObjectBreadCrumb :railObjectId="breadCrumbRailObjectId" @set-parent="setParent" ref="breadcrumb" v-on:update:railObjectId="onUpdateBreadCrumbRailObjectId($event)" />
      </div>

      <div v-if="children && children.length>0" class="breadcrumb-div" @mouseenter="railObjectChildrenVisible = true" @mouseleave="railObjectChildrenVisible = false">
        <span class="breadcrumb-link-main" @click="railObjectChildrenVisible = true">{{childObjectName!=null ? childObjectName : '...'}}</span>
        <transition name="slide-fade">
          <div v-if="railObjectChildrenVisible" class="dialog no-padding inner-content">
            <div class="inner-breadcrumb-content z-depth-3">
              <table class="breadcrumb-table striped highlight">
                <thead>
                  <th>
                    <span>{{ $t('views.breadcrumb.railobject') }}</span>
                    <span class="right" @click="railObjectChildrenVisible = false"><i class="material-icons clickable">cancel</i></span>
                  </th>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in children" :key="index">
                    <td @click="setChild(item)"><span class="clickable" v-bind:class="{ 'alarm': item.monitorStatusId===3, 'warning': item.monitorStatusId===2  }">{{ item.Name }}</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </transition>
      </div>

    <StatusIcons v-if="parentRailObject" :rail-object="parentRailObject" :child-objects="childObjects" />
    </div>
    <div class="col s12">
      <div class="row" v-if="railObject">
        <ul id="switch-tabs" class="tabs z-depth-1">
          <li class="tab col"><a v-bind:class="{'active': activeTab === 'events'}" @click="selectTab('events')">{{ $t('views.switch.tabs.events') }}</a></li>
          <!--<li class="tab col"><a v-bind:class="{'active': activeTab === 'alarmsettings'}" @click="selectTab('alarmsettings')">{{ $t('views.switch.tabs.alarmsettings') }} <span v-if="parentRailObject ? parentRailObject.AlarmSettingsAreDefault : false" :title="$t('views.switch.defaultalarmsettings')"><i style="vertical-align: middle;" class="material-icons">comment</i></span></a></li> -->
          <li class="tab col"><a v-bind:class="{'active': activeTab === 'alarmconfiguration'}" @click="selectTab('alarmconfiguration')">{{ $t('views.switch.tabs.alarmsettings') }} </a></li>
          <li class="tab col"><a v-bind:class="{'active': activeTab === 'analysis'}" @click="selectTab('analysis')">{{ $t('views.switch.tabs.analysis') }}</a></li>
          <li class="tab col"><a v-bind:class="{'active': activeTab === 'logs'}" @click="selectTab('logs')">{{ $t('views.switch.tabs.logs') }}</a></li>
          <li class="tab col"><a v-bind:class="{'active': activeTab === 'info'}" @click="selectTab('info')">{{ $t('views.switch.tabs.info') }}</a></li>
          <li class="tab col"><a v-bind:class="{'active': activeTab === 'sections'}" @click="selectTab('sections')">{{ $t('views.switch.tabs.sections') }}</a></li>
          <li class="tab col"><a v-bind:class="{'active': activeTab === 'earthfault'}" @click="selectTab('earthfault')">{{ $t('views.switch.tabs.earthfault') }}</a></li>
        </ul>
        <div v-if="activeTab === 'events'" id="events" class="col s12">
          <SwitchEvents
            :switch-object="railObject"
            :measurementId="measurementId"
            :sensorData="sensorData"
            :title="breadCrumb" />
        </div>
        <div v-if="activeTab === 'logs'" class="col s12">
              <Logs :rail-object="railObject" />
          </div>
          <div v-if="activeTab === 'info'" class="col s12">
            <SwitchInfo :rail-object="parentRailObject" :child-objects="childObjects" />
          </div>
        <!--<div v-if="activeTab === 'alarmsettings'" class="col s12">
          <AlarmSettings :rail-object="parentRailObject" />
        </div>-->
        <div v-if="!isSpecialSensor">
          <div v-if="activeTab === 'alarmconfiguration'" class="col s12">
            <AlarmConfiguration :asset="parentRailObject" :selected-asset="railObject" />
          </div>
          <div v-if="activeTab === 'analysis'" class="col s12">
            <Analysis :rail-object="railObject" :complex-object="complexObject"/>
          </div>
          <div v-if="activeTab === 'sections'" class="col s12">
            <Sections :asset="parentRailObject" :selected-asset="railObject" />
          </div>
          <div v-if="activeTab === 'earthfault'" class="col s12">
            <EarthFault :complex-object="complexObject" :selected-asset="railObject" :rail-object="parentRailObject" :child-objects="childObjects" />
          </div>
        </div>
        <div v-if="isSpecialSensor">
          <div v-if="activeTab === 'alarmconfiguration' || activeTab === 'analysis' || activeTab === 'sections' || activeTab === 'earthfault'" class="col s12">
            <div class="row">
              <div class="col s12 z-depth-1 white">
                <div class="col s3 SpecialSensor">
                    <span class="title" style="padding-left: 11px;">This option is not available for the selected sensor</span>
               </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Spinner v-if="!railObject" />
    </div>
  </div>
</template>

<script>
import SwitchEvents from './SwitchEvents'
import AlarmSettings from './AlarmSettings'
import Analysis from './Analysis'
import Logs from './Logs'
import SwitchApi from '../../services/api/switch/SwitchApi'
import Router from '../../router'
import SwitchService from '../../services/SwitchService'
import RegionsService from '../../services/RegionService'
import DepartmentsService from '../../services/DepartmentService'
import RailObjectService from '../../services/RailObjectService'
import RailObjectBreadCrumb from '../../components/RailObjectBreadCrumb'
import ChildSelector from '../../components/switch/ChildSelector'
import StatusIcons from '../../components/switch/StatusIcons'
import SwitchInfo from './SwitchInfo'
import Spinner from '@/components/Spinner'
import Sections from './_sections/Sections'
import SensorService from '../../services/SensorService'
import EarthFault from './_earthfault/EarthFault'
import AlarmConfiguration from './AlarmConfiguration.vue'

export default {
  name: 'switchPage',
  data () {
    return {
      active: null,
      switchObject: null,
      railObject: null,
      breadCrumbRailObjectId: null,
      measurementId: null,
      showResetStatus: false,
      showEditOpModeStatus: false,
      showEditLastMaintDate: false,
      activeRailObjectId: null,
      childObjects: [],
      relatedObjects: [],
      analysisLoaded: false,
      railObjectChildrenVisible: false,
      childObjectName: null,
      parentRailObject: null,
      motorId: Number,
      activeTab: 'events',
      sensorData: null
    }
  },
  components: {
    StatusIcons,
    SwitchEvents,
    AlarmSettings,
    AlarmConfiguration,
    Analysis,
    Logs,
    SwitchInfo,
    RailObjectBreadCrumb,
    ChildSelector,
    Spinner,
    Sections,
    EarthFault
  },
  computed: {
    breadCrumb: function () {
      if (this.switchObject) {
        var regionName = RegionsService.getRegionByRegionId(this.switchObject.RegionId).Name
        var departmentName = DepartmentsService.getDepartmentByDepartmentId(this.switchObject.DepartmentId).Name
        return regionName + ' / ' + departmentName + ' / ' + this.switchObject.ComplexName + ' / '
      } else {
        return ''
      }
    },
    complexObject () {
      return this.parentRailObject
    },
    children () {
      return this.childObjects[0] ? this.childObjects[0].childObjects : []
    },
    railObjectName: function () {
      if (this.switchObject) {
        return this.switchObject.Name
      } else {
        return ''
      }
    },
    editMonitorStatusDisabled: function () {
      var result = true
      if (this.switchObject) {
        result = this.switchObject.MonitorStatusId === 1
        if (!result) {
          // check if user has permission
          var permissionIdx = this.switchObject.FunctionCodes.indexOf('RESA')
          if (permissionIdx < 0) {
            result = true
          }
        }
      }
      return result
    },
    isSpecialSensor: function () {
      if (this.childObjectName != null && this.childObjectName.includes('Oil Low')) {
        return true
      }
      return false
    }
  },
  watch: {
    $route (to, from) {
      // SwitchService.clear()
      if (Router.currentRoute.params['motorId'] && !isNaN(Router.currentRoute.params['motorId'])) {
        this.motorId = Number(Router.currentRoute.params['motorId'])
      } else {
        this.motorId = undefined
      }
      this.clearChildren()
      // PO-1003
      if (Router.currentRoute.params['id']) {
        var id = Router.currentRoute.params['id']
        var measurementid = null
        if (Router.currentRoute.params['measurementId']) {
          var mid = Router.currentRoute.params['measurementId']
          if (isNaN(mid)) {
            measurementid = null
          } else {
            measurementid = Number(mid)
          }
        }
        this.getSwitch(id, measurementid)
      }
    }
  },
  mounted: async function () {
    if (Router.currentRoute.params['id']) {
      const id = Router.currentRoute.params['id']
      let measurementId = null

      // Extract measurementId from route params (e.g. /switch/:id/:measurementId)
      if (Router.currentRoute.params['measurementId']) {
        const mid = Router.currentRoute.params['measurementId']
        measurementId = isNaN(mid) ? null : Number(mid)
      }

      if (Router.currentRoute.params['motorId'] && !isNaN(Router.currentRoute.params['motorId'])) {
        this.motorId = Number(Router.currentRoute.params['motorId'])
      } else {
        this.motorId = undefined
      }
      await this.getSwitch(id, measurementId)
    } else {
      this.measurementId = null
    }
  },
  beforeDestroy () {
    SwitchService.clear()
  },
  methods: {
    getSensorInformation (railobjectId) {
      SensorService.GetSensorInformation(railobjectId).then(result => {
        this.sensorData = result.data
      })
    },
    async setParent (val) {
      await this.changeRailObject(val)
    },
    hideBreadCrumbs () {
      var bc = this.$refs.breadcrumb
      bc.toggleAll(false)
    },
    async getSwitch (railObjectId, measurementId) {
      if (railObjectId) {
        let switchObj = null
        let switchObjData = await SwitchApi.getSwitch(railObjectId, measurementId)
        let childObjData = null
        const obj = switchObjData.data

        // Determine child or parent
        if (obj.ParentRailObjectId === null) {
          switchObj = switchObjData.data
        } else {
          childObjData = obj
          switchObjData = await SwitchApi.getSwitch(obj.ParentRailObjectId, measurementId)
          switchObj = switchObjData.data
        }

        SwitchService.setSwitch(switchObj)

        this.fillHierarchy(switchObj)

        let motors = this.children.filter(c => c.Id === this.motorId)
        if (this.motorId && motors && motors.length > 0) {
          this.setChild(motors[0])
        } else {
          this.switchObject = switchObj
          this.railObject = this.switchObject
        }

        if (measurementId) {
          this.measurementId = measurementId
        } else {
          if (switchObj.LastMeasurementId) {
            this.measurementId = switchObj.LastMeasurementId
          } else {
            if (switchObj.TimeLineMeasurements && switchObj.TimeLineMeasurements.length > 0) {
              this.measurementId = switchObj.TimeLineMeasurements[switchObj.TimeLineMeasurements.length - 1].MeasurementId
            } else {
              this.measurementId = null
            }
          }
        }
        SwitchService.setMeasurementId(this.measurementId)

        // Make sure to preselect child if a child object is requested
        if (childObjData !== null) {
          this.childObjectName = childObjData.Name
          this.railObject = childObjData
          this.switchObject = childObjData
          this.breadCrumbRailObjectId = childObjData.RailObjectId
        } else {
          this.breadCrumbRailObjectId = switchObj.RailObjectId
        }
      }
    },
    async changeRailObject (railObjectId) {
      var railObject = null
      if (this.switchObject) {
        if (railObjectId) {
          if (this.switchObject.RailObjectId !== railObjectId) {
            railObject = RailObjectService.getRailObjectByRailObjectId(railObjectId)
            if (railObject) {
              await this.getSwitch(railObjectId, railObject.LastMeasurementId)
            }
          }
        } else {
          this.clearChildren()
          SwitchService.clear()
          this.switchObject = null
          this.railObject = null
        }
      } else {
        if (railObjectId) {
          railObject = RailObjectService.getRailObjectByRailObjectId(railObjectId)
          if (railObject) {
            await this.getSwitch(railObjectId, railObject.LastMeasurementId)
          }
        }
      }
      this.childObjectName = null
    },
    async setChild (childObject) {
      this.railObjectChildrenVisible = false
      if (childObject) {
        const switchObjData = await SwitchApi.getSwitch(childObject.Id, this.measurementId)
        this.railObject = switchObjData.data
        this.switchObject = switchObjData.data
      } else {
        this.railObject = this.switchObject
      }
      this.childObjectName = this.railObject.Name
      this.childObjectName = childObject.Name
    },
    loadAnalysis () {
      this.analysisLoaded = true
    },
    setActive (obj) {
      if (obj.possObjectCodeId === 3 || obj.possObjectCodeId === 19) {
        this.childObjects.forEach(element => {
          if (element.Id === obj.Id) {
            element.isActive = true
          } else {
            element.isActive = false
          }
          if (element.hasChildren) {
            this.setTreeActiveFlag(element.childObjects, obj.Id)
          }
        })
        this.activeRailObjectId = obj.Id
      }
    },
    setTreeActiveFlag (children, newId) {
      if (children) {
        children.forEach(element => {
          if (element.Id === newId) {
            element.isActive = true
          } else {
            element.isActive = false
          }
          if (element.hasChildren) {
            this.setTreeActiveFlag(element.childObjects, newId)
          }
        })
      }
    },
    fillHierarchy (obj) {
      var result = []
      this.parentRailObject = obj

      if (obj) {
        var parent = {
          Id: obj.RailObjectId,
          Name: obj.Name,
          childObjects: [],
          hasChildren: false,
          isActive: true,
          isRelay: false,
          isSelectable: true,
          possObjectCodeId: obj.PossObjectCodeId
        }
        if (obj.PointDrives) {
          obj.PointDrives.forEach(element => {
            // check for children
            parent.hasChildren = true
            parent.childObjects.push({
              Id: element.RailObjectId,
              Name: element.Name,
              childObjects: [],
              hasChildren: false,
              isRelay: false,
              isActive: false,
              isSelectable: true,
              possObjectCodeId: element.PossObjectCodeId,
              monitorStatusId: element.MonitorStatusId,
              ExternalId: element.ExternalId
            })
            if (element.Relays) {
              element.hasChildren = true
              element.Relays.forEach(crelay => {
                element.childObjects.push({
                  Id: crelay.RailObjectId,
                  Name: crelay.Name,
                  childObjects: [],
                  isActive: false,
                  isRelay: true,
                  isSelectable: false,
                  possObjectCodeId: crelay.PossObjectCodeId,
                  externalId: crelay.ExternalId
                })
              })
            }
          })
        }
        if (obj.SwitchAxleCounters) {
          parent.hasChildren = true
          obj.SwitchAxleCounters.forEach(axleCounter => {
            parent.childObjects.push({
              Id: axleCounter.RailObjectId,
              Name: axleCounter.Name,
              childObjects: [],
              isActive: false,
              isRelay: true,
              isSelectable: false,
              possObjectCodeId: axleCounter.PossObjectCodeId,
              externalId: axleCounter.ExternalId
            })
          })
        }
        if (obj.Relays) {
          parent.hasChildren = true
          obj.Relays.forEach(relay => {
            parent.childObjects.push({
              Id: relay.RailObjectId,
              Name: relay.Name,
              childObjects: [],
              isActive: false,
              isRelay: true,
              isSelectable: false,
              possObjectCodeId: relay.PossObjectCodeId,
              externalId: relay.ExternalId
            })
          })
        }
        result.push(parent)
      }
      this.childObjects = result
      var relatedresult = []
      if (obj.SwitchPeriodicObjects && obj.SwitchPeriodicObjects.length > 0) {
        if (obj.ComplexPeriodicObjects && obj.ComplexPeriodicObjects.length > 0) {
          relatedresult = obj.SwitchPeriodicObjects.concat(obj.SwitchPeriodicObjects)
        } else {
          relatedresult = obj.SwitchPeriodicObjects
        }
      } else {
        if (obj.ComplexPeriodicObjects && obj.ComplexPeriodicObjects.length > 0) {
          relatedresult = obj.ComplexPeriodicObjects
        }
      }
      this.relatedObjects = relatedresult
    },
    clearChildren () {
      this.childObjectName = null
      this.childObjects = []
      this.relatedObjects = []
      this.activeRailObjectId = null
    },
    editMonitorStatus () {
      if (!this.editMonitorStatusDisabled) {
        this.showResetStatus = true
      }
    },
    editOperationalStatus () {
      this.showEditOpModeStatus = true
    },
    editMaintenanceDate () {
      this.showEditLastMaintDate = true
    },
    selectTab (tab) {
      this.activeTab = tab
    },
    onUpdateBreadCrumbRailObjectId (railObjectId) {
      this.breadCrumbRailObjectId = railObjectId
      this.changeRailObject(railObjectId)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #switch-page {
    width: 100%;
    height: calc(100vh - 56px);
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .breadcrumb {
    font-family: Roboto;
    font-size: 24px;
    font-weight: normal;
    font-style: normal;
    line-height: 32px;
    color: rgba(0, 0, 0, .56)
  }

  .no-margin-bottom {
    margin-bottom: 0px;
  }

  /* #switch-tabs {
    margin-left: -10px;
    right: 0;
    width: 100%;
  }*/
  .tabs-row-spacer {
    margin-bottom: 10px;
  }

  .content-box {
    padding-top: 10px;
    margin-left: 5px;
    padding-left: 11px;
    padding-right: 11px;
  }

  .status-warning {
    color: #FFA842;
  }

  .status-alarm {
    color: #C91414
  }

  .headline {
    font-family: Roboto;
    font-size: 24px;
    font-weight: normal;
    font-style: normal;
    line-height: 32px;
    color: rgba(0, 0, 0, 0.87)
  }

  .title {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    font-size: 20px;
    line-height: 23px;
    color: rgba(0, 0, 0, 0.87);
  }

  .subheader {
    font-family: Roboto;
    font-size: 16pt;
    color: #000000;
  }

  .body2-menu {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.87);
  }

  .menu-list-grid-subheader {
    font-family: Roboto;
    font-size: 14pt;
    color: rgba(0, 0, 0, 0.54);
  }

  .body1-secondary {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.40);
  }

  .caption {
    font-family: Roboto;
    font-size: 12pt;
    color: rgba(0, 0, 0, 0.54);
  }

  .color-label {
    font-family: Roboto;
    font-size: 14pt;
    text-transform: uppercase;
    color: rgba(0, 188, 212, 0.54);
  }

  .button-icon {
    cursor: pointer;
    color: #56CCF2;
  }

  .button-disabled {
    cursor: default;
    color: #E0E0E0;
  }

  .button-label-primary {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    font-size: 12px;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: #56CCF2;
    cursor: pointer;
  }

  .componenttree-label {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    font-size: 12px;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: rgba(0, 0, 0, 0.87);
    cursor: pointer;
  }

  ul.componenttree, ul.componenttree ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  ul.componenttree ul {
    margin-left: 10px;
  }

  ul.componenttree li {
    margin: 0;
    padding: 0 7px;
    line-height: 20px;
    font-family: Roboto;
    color: rgba(0, 0, 0, 0.87);
    border-left: 1px solid rgb(100, 100, 100);
  }

  ul.componenttree li:last-child {
    border-left: none;
  }

  ul.componenttree li:before {
    position: relative;
    top: -0.3em;
    height: 1em;
    width: 12px;
    color: white;
    border-bottom: 1px solid rgb(100, 100, 100);
    content: "";
    display: inline-block;
    left: -7px;
  }

  ul.componenttree li:last-child:before {
    border-left: 1px solid rgb(100, 100, 100);
  }

  .componenttree-span {
    width: 100%;
    font-family: Roboto;
    font-weight: 500;
    font-style: normal;
    line-height: 24px;
    font-size: 12px;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: rgba(0, 0, 0, 0.87);
    cursor: pointer;
  }

  .active-object {
    color: #56CCF2 !important;
  }

  .treeItemNotSelectable {
    font-style: italic !important;
    cursor: none !important;
  }

  .switch-page-spacing {
    margin-right: 12px;
  }

  select {
    height: auto !important;
  }

  .breadcrumb-div {
    display: inline-block;
  }

  .breadcrumb-link {
    font-family: Roboto;
    font-size: 24px;
    font-weight: normal;
    font-style: normal;
    line-height: 32px;
    color: rgba(0,0,0, .56);
    /* cursor: pointer; */
  }
  .breadcrumb-link-main {
    font-family: Roboto;
    font-size: 24px;
    font-weight: normal;
    font-style: normal;
    line-height: 32px;
    color: rgba(0, 0, 0, 0.87);
    /* cursor: pointer; */
  }
  .inner-breadcrumb-content {
    max-height: 300px;
    width: 345px;
    overflow-y: auto;
    background-color: white;
    /* border: 1px solid  rgba(0, 0, 0, 0.56); */
    font-family: Roboto;
  }
  .breadcrumb-table {
    position: relative;
  }
  .breadcrumb-table thead tr {
    border-top: 1px solid rgba(0, 0, 0, 0.4);
    border-bottom: 1px solid rgba(0, 0, 0, 0.4);
  }
  .breadcrumb-table th, .breadcrumb-table td {
    padding: 5px 5px;
  }
  .inner-content {
    position: fixed;
    z-index: 4;
  }
  .slide-fade-enter-active {
    transition: all .4s ease;
  }
  .slide-fade-leave-active {
    transition: all .2s ease;
  }
  .slide-fade-enter {
    transform: translateY(-50px);
    opacity: 0;
  }
  .slide-fade-leave-to {
    transform: translateY(-50px);
    opacity: 0;
  }
  table.highlight tbody tr:hover {
    background-color: #eee !important;
 }
 .alarm {
  color: red
}

.warning {
  color: orange
}

.tabs a:not(.active) {
  cursor: pointer;
}

.tabs .active {
  border-bottom: 2px solid #56CCF2;
}

.SpecialSensor {
  padding-top: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/switch/Switch.vue